import { orchestrator } from 'satcheljs';
import { startDomainEnroll } from '../actions/startDomainEnroll';
import { traceCreateEmailButtonClick } from '../utils/domainOptionTracer';
import { hideFullOptions } from 'owa-options-core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PremiumDomainConnectFirstStep } from 'owa-domain-connect';

export default orchestrator(startDomainEnroll, async function startDomainEnroll() {
    traceCreateEmailButtonClick();
    hideFullOptions();
    mountDomainConnectFirstStep();
});

function mountDomainConnectFirstStep() {
    var dcFirstStepContainer = document.createElement('div');
    document.body.appendChild(dcFirstStepContainer);
    ReactDOM.render(
        <PremiumDomainConnectFirstStep
            mountFromDomainDashBoard={true}
            onClose={() => {
                ReactDOM.unmountComponentAtNode(dcFirstStepContainer);
                document.body.removeChild(dcFirstStepContainer);
            }}
        />,
        dcFirstStepContainer
    );
}
